import {
  DefinePermissionEnum,
  DefinePermissionModuleEnum,
} from 'app/api/role/constant'
import { IPermission } from 'app/api/role/model'
import R from 'app/assets/R'
import { BaseCheckbox } from 'app/components/common/BaseCheckbox'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { groupPermissionsByModule, usePagination } from 'app/hook'
import { useGetPermissionList } from 'app/react-query/hook/role'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const FormRoleCommon = ({
  isDefault,
  onChangeIsDefault,
}: {
  isDefault?: boolean
  onChangeIsDefault?: (val: boolean) => void
}) => {
  const { t } = useTranslation()

  const { flattenDataList } = usePagination()
  const { data: dataPermission, isLoading: isLoadingPermission } =
    useGetPermissionList()

  const permissions: IPermission[] = useMemo(() => {
    return flattenDataList(dataPermission)?.data
  }, [dataPermission])

  const permissionGroup = useMemo(() => {
    return groupPermissionsByModule(permissions ?? [])
  }, [permissions])

  return (
    <BaseSpace size={5}>
      <BaseForm.Item
        name={'name'}
        required
        label={t(R.strings.name_role)}
        rules={[
          {
            required: true,
            message: t(R.strings.require_field, {
              field: t(R.strings.name_role),
            }),
          },
        ]}
      >
        <BaseInput placeholder={'Nhập tên quyền'} />
      </BaseForm.Item>
      <BaseForm.Item name={'description'} label={t(R.strings.description)}>
        <BaseInput placeholder={t(R.strings.enter_description)} />
      </BaseForm.Item>

      <BaseForm.Item
        name={'permissionIds'}
        label={t(R.strings.permission)}
        required
        rules={[
          {
            required: true,
            message: t(R.strings.require_field, {
              field: t(R.strings.permission),
            }),
          },
        ]}
      >
        <BaseSelect
          placeholder={t(R.strings.select_permission)}
          showSearch
          loading={isLoadingPermission}
          mode="multiple"
          maxTagCount={2}
          options={permissionGroup?.map(item => ({
            label: item?.module
              ? t(DefinePermissionModuleEnum?.[item?.module]?.keyI18n)
              : item?.module,
            options: item?.permissions?.map(item => ({
              label: item?.permission
                ? t(DefinePermissionEnum?.[item?.permission]?.keyI18n)
                : item?.name,
              value: item?.id,
            })),
          }))}
          filterSort={() => 0}
        />
      </BaseForm.Item>
      <BaseRow gutter={8} align={"middle"}>
        <BaseCol>
          <BaseCheckbox
            checked={isDefault}
            onChange={e => onChangeIsDefault?.(e?.target?.checked)}
          />
        </BaseCol>
        <BaseCol>
          <BaseText children={'Đặt làm mặc định khi tạo đoàn viên/ tài khoản'} fontWeight="medium" />
        </BaseCol>
      </BaseRow>
    </BaseSpace>
  )
}
